__webpack_require__.p = "https://marketing-edge-assets.lemonade.com/_next/";